import React from "react";
import { Button } from "../core/Button.jsx";

const field = {
  width: "100%", minHeight: 44, padding: "10px 2px",
  background: "transparent",
  border: 0,
  borderBottom: "1px solid var(--rule)",
  borderRadius: "var(--radius-none)",
  fontFamily: "var(--font-display)", fontSize: "var(--fs-body-l)", color: "var(--fg-primary)",
  outline: "none",
};
const labelStyle = {
  fontFamily: "var(--font-display)", fontStyle: "italic", fontSize: "var(--fs-body)",
  letterSpacing: "0.01em", color: "var(--fg-muted)",
};

/** RSVP form — attendance, headcount and an optional message. The invitation is personal, so the guest's name is stated, not asked. */
export function RsvpForm({ guest = "", maxPasses = 2, deadline, guestEditable = false, onSubmit, submitted = false, style }) {
  const [name, setName] = React.useState(guest);
  const [attending, setAttending] = React.useState("si");
  const [count, setCount] = React.useState(maxPasses);
  const [message, setMessage] = React.useState("");
  React.useEffect(() => { setName(guest); setCount(maxPasses); }, [guest, maxPasses]);

  if (submitted) {
    return (
      <div style={{ textAlign: "center", padding: "var(--sp-7) var(--sp-5)", ...style }}>
        <p style={{ margin: 0, fontFamily: "var(--font-flourish, var(--font-script))", fontSize: "var(--fs-title-l)", lineHeight: 1.3, padding: "0 .1em .1em", color: "var(--accent)" }}>¡Gracias!</p>
        <p style={{ margin: "var(--sp-3) 0 0", fontFamily: "var(--font-display)", fontStyle: "italic", fontSize: "var(--fs-body-l)", color: "var(--fg-secondary)" }}>Hemos recibido tu confirmación.</p>
      </div>
    );
  }

  const chips = maxPasses <= 6;

  return (
    <form
      style={{ display: "grid", gap: "var(--sp-5)", ...style }}
      onSubmit={(e) => { e.preventDefault(); onSubmit && onSubmit({ name, attending, count: attending === "si" ? count : 0, message }); }}
    >
      {guestEditable ? (
        <label style={{ display: "grid", gap: 8 }}>
          <span style={labelStyle}>Nombre completo</span>
          <input style={field} value={name} onChange={(e) => setName(e.target.value)} placeholder="Tu nombre" required />
        </label>
      ) : (
        <p style={{ margin: 0, textAlign: "center", fontFamily: "var(--font-display)", fontStyle: "italic", fontSize: "var(--fs-body-l)", lineHeight: "var(--lh-snug)", color: "var(--fg-secondary)" }}>
          Confirmamos para <span style={{ fontStyle: "normal", color: "var(--fg-primary)" }}>{name || "nuestro invitado"}</span>
        </p>
      )}

      <fieldset style={{ border: 0, padding: 0, margin: 0, display: "grid", gap: 10 }}>
        <span style={{ ...labelStyle, textAlign: "center" }}>¿Nos acompañas?</span>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "var(--sp-4)" }}>
          {[["si", "Sí, asistiré"], ["no", "No podré"]].map(([v, l]) => (
            <button key={v} type="button" onClick={() => setAttending(v)} style={{
              minHeight: 46, padding: "12px 8px",
              fontFamily: "var(--font-display)", fontSize: "var(--fs-body-l)",
              border: 0,
              borderBottom: "1px solid " + (attending === v ? "var(--accent)" : "var(--rule)"),
              background: attending === v ? "color-mix(in srgb, var(--accent-soft) 45%, transparent)" : "transparent",
              color: attending === v ? "var(--accent)" : "var(--fg-muted)",
              transition: "all var(--dur-fast) var(--ease-standard)",
            }}>{l}</button>
          ))}
        </div>
      </fieldset>

      {attending === "si" && maxPasses > 1 && (
        <fieldset style={{ border: 0, padding: 0, margin: 0, display: "grid", gap: 10, justifyItems: "center" }}>
          <span style={labelStyle}>¿Cuántos asistirán?</span>
          {chips ? (
            <div style={{ display: "flex", gap: "var(--sp-3)", flexWrap: "wrap", justifyContent: "center" }}>
              {Array.from({ length: maxPasses }, (_, i) => i + 1).map((n) => (
                <button key={n} type="button" onClick={() => setCount(n)} aria-pressed={count === n} style={{
                  width: 46, height: 46, borderRadius: "50%",
                  fontFamily: "var(--font-display)", fontSize: "var(--fs-body-l)",
                  border: "1px solid " + (count === n ? "var(--accent)" : "var(--rule)"),
                  background: count === n ? "var(--accent-soft)" : "transparent",
                  color: count === n ? "var(--accent)" : "var(--fg-muted)",
                  transition: "all var(--dur-fast) var(--ease-standard)", cursor: "pointer",
                }}>{n}</button>
              ))}
            </div>
          ) : (
            <select style={{ ...field, maxWidth: 200, textAlign: "center" }} value={count} onChange={(e) => setCount(Number(e.target.value))}>
              {Array.from({ length: maxPasses }, (_, i) => i + 1).map((n) => (<option key={n} value={n}>{n}</option>))}
            </select>
          )}
        </fieldset>
      )}

      <label style={{ display: "grid", gap: 8 }}>
        <span style={labelStyle}>Mensaje para los novios <span style={{ fontStyle: "normal", fontSize: "var(--fs-caption)" }}>(opcional)</span></span>
        <textarea rows={2} style={{ ...field, minHeight: 48, resize: "vertical" }} value={message} onChange={(e) => setMessage(e.target.value)} />
      </label>

      <Button type="submit" variant="solid" size="lg" full>Enviar confirmación</Button>
      {deadline && (
        <p style={{ margin: 0, textAlign: "center", fontFamily: "var(--font-display)", fontStyle: "italic", fontSize: "var(--fs-body)", color: "var(--fg-muted)" }}>Confirma antes del {deadline}</p>
      )}
    </form>
  );
}
